/* batida-v7-okazje.js: "na jaką okazję?" bar under the home hero (sections/batida-v7-okazje.liquid).
   A chip shows its occasion's links (all links are in the page already; this only moves the hidden attribute and
   aria-pressed). Nothing changes by itself. Without the script the occasion chosen in the editor stays visible.
   On phones a chip half out of view is scrolled into the row. Theme editor: picking a block shows that occasion.
   29.09 (Aleksandra): from 1200 px the bar is always one row. fit() checks whether the chosen occasion fits and, if
   not, hides "polecamy" (data-v7ok-fit="1") and then links 3-4 (data-v7ok-fit="2"); styles in batida-v7-okazje.css.
   Checked on load, after the fonts arrive, on resize and whenever another occasion is chosen. */
(function () {
  'use strict';
  if (window.__v7ok) return;
  window.__v7ok = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var oneRow = window.matchMedia ? window.matchMedia('(min-width: 1200px)') : null;

  // one row (1200+): step down until the chosen occasion fits - 1 = without "polecamy", 2 = only its first two links
  function fit(root) {
    if (!root) return;
    var row = root.querySelector('.v7ok__in');
    root.removeAttribute('data-v7ok-fit');
    if (!row || !oneRow || !oneRow.matches) return;
    for (var lvl = 1; lvl <= 2 && row.scrollWidth > row.clientWidth + 1; lvl++) root.setAttribute('data-v7ok-fit', String(lvl));
  }
  function fitAll() { document.querySelectorAll('[data-v7ok]').forEach(fit); }

  function select(root, chip) {
    if (!root || !chip) return;
    var id = chip.getAttribute('data-v7ok-chip');
    root.querySelectorAll('[data-v7ok-chip]').forEach(function (c) {
      c.setAttribute('aria-pressed', c === chip ? 'true' : 'false');
    });
    root.querySelectorAll('[data-v7ok-panel]').forEach(function (p) {
      if (p.getAttribute('data-v7ok-panel') === id) {
        p.classList.remove('is-anim');
        p.hidden = false;
        void p.offsetWidth; // restart the links' entrance
        p.classList.add('is-anim');
      } else {
        p.hidden = true;
        p.classList.remove('is-anim');
      }
    });
    fit(root);
    // phones: bring a chip that is cut off at the edge fully into the row (sideways only, the page does not move)
    var row = chip.parentElement;
    if (row && row.scrollWidth > row.clientWidth + 1) {
      var r = row.getBoundingClientRect();
      var b = chip.getBoundingClientRect();
      var dx = 0;
      if (b.left < r.left + 20) dx = b.left - r.left - 20;
      else if (b.right > r.right - 20) dx = b.right - r.right + 20;
      if (dx) {
        try { row.scrollBy({ left: dx, behavior: reduce ? 'auto' : 'smooth' }); } catch (e) { row.scrollLeft += dx; }
      }
    }
  }

  document.addEventListener('click', function (e) {
    var chip = e.target.closest && e.target.closest('[data-v7ok-chip]');
    if (!chip) return;
    if (chip.getAttribute('aria-pressed') === 'true') return;
    select(chip.closest('[data-v7ok]'), chip);
  });

  var fitQueued = false;
  function queueFit() {
    if (fitQueued) return;
    fitQueued = true;
    (window.requestAnimationFrame || setTimeout)(function () { fitQueued = false; fitAll(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fitAll); else fitAll();
  window.addEventListener('load', fitAll);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitAll);
  window.addEventListener('resize', queueFit);
  document.addEventListener('shopify:section:load', fitAll);

  // theme editor: clicking an "Okazja" block in the sidebar shows it
  document.addEventListener('shopify:block:select', function (e) {
    var chip = e.target;
    if (chip && chip.matches && chip.matches('[data-v7ok-chip]')) select(chip.closest('[data-v7ok]'), chip);
  });
})();
